export const dataURLtoFile = (
  dataurl: string,
  filename: string,
): { file: File; error: string | null } => {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)?.[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  const file = new File([u8arr], filename, { type: mime })
  let error: string | null = null

  const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10MB in bytes

  if (file.size > MAX_FILE_SIZE) {
    error = 'Image size must be less than 10MB. Please try capturing again from a bit further away.'
    return { file, error }
  } else {
    return { file, error: null }
  }
}
